import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import { printLogs } from "../../utils";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("userDetails", null);
  const [userType, setUserType] = useLocalStorage("userType", null);
  const [token, setToken] = useLocalStorage("userToken", null)
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data, type) => {
    printLogs("🚀 ~ login ~ data:", data)
    setUser(data);
    setUserType(type)
    setToken(data?.Token)
    if (type == 'admin') navigate("/admin/businessListContacts", { replace: true });
    if (type == 'user') navigate("/user/search", { replace: true });
  };

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null);
    setUserType(null);
    localStorage.clear();
    navigate("/", { replace: true });
  };

  const value = useMemo(
    () => ({
      user,
      userType,
      login,
      logout,
      token
    }),
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};